// extracted by mini-css-extract-plugin
export default {"shrink-svg":"ShrinkSVG-module__shrink-svg__20gm8"};